import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/message_stroke"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69558 11.401L2.72643 10.9074L2.52368 10.4564C2.18784 9.70916 2 8.87921 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C7.12076 14 6.29077 13.8121 5.54355 13.4763L5.09246 13.2735L4.59885 13.3044L2.56869 13.4313L2.69558 11.401ZM1.56232 15.4981L2.44295 15.443L4.7236 15.3005C5.72357 15.7499 6.83258 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 9.16737 0.250035 10.2763 0.699471 11.2763L0.556927 13.557L0.501887 14.4376L0.431192 15.5687L1.56232 15.4981ZM4.29286 7.29289C4.68339 6.90237 5.31655 6.90237 5.70708 7.29289C6.0976 7.68342 6.0976 8.31658 5.70708 8.70711C5.31655 9.09763 4.68339 9.09763 4.29286 8.70711C3.90234 8.31658 3.90234 7.68342 4.29286 7.29289ZM7.29286 8.70711C7.68339 9.09763 8.31655 9.09763 8.70708 8.70711C9.0976 8.31658 9.0976 7.68342 8.70708 7.29289C8.31655 6.90237 7.68339 6.90237 7.29286 7.29289C6.90234 7.68342 6.90234 8.31658 7.29286 8.70711ZM10.2929 8.70711C10.6834 9.09763 11.3166 9.09763 11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289C9.90234 7.68342 9.90234 8.31658 10.2929 8.70711Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { MessageStroke16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var MessageStroke16 = createIcon(IconComponent);